import { SET_VIEW_MODE } from "../../constants/Application";

export const switchViewMode = () => dispatch =>
  dispatch({ type: SET_VIEW_MODE });
